module.exports = __webpack_public_path__ + "static/img/circle1.3783414.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/index/smart/circle1.png
// module id = Mvae
// module chunks = 0 2